import React, { Component } from 'react';
import _ from 'lodash';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import commonUtil from '../../../../../utils/commonUtil';
import TextInput from '../../../../../components/ZUILib/TextInput';


const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
export default class TarjetaLiverpool extends Component {
  constructor(props) {
    super(props);
    this.accountNumber = null;
    this.accountId = null;
    this.bonusToolTipMessage = null;
    this.state = {
      transferenceData: this.props.transferenceData,
      selectedRadioSavedCardsInfoValue: null,
    };
  }
  UNSAFE_componentWillMount() {
    if (this.state.transferenceData.employeeCardInfo && this.state.transferenceData.employeeCardInfo.length === 1) {
      this.props.disableContinueButton(false);
      // if (this.state.transferenceData.employeeCardInfo.length === 1) {
      // this.walletType = _.find(this.state.transferenceData.transferenceOptions.transferenceMethods, { code: '1' }).name;
      // this.accountNumber = this.state.transferenceData.employeeCardInfo[0].accountNumber;
      // this.accountId = this.state.transferenceData.employeeCardInfo[0].accountId;
      // this.props.disableContinueButton(false);
      // }
    }
    this.bonusToolTipMessage = commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.tarjetaLiverpool.bonusStatement');
  }
  handleRadioSelected = (data, e) => {
    this.setState({ selectedRadioSavedCardsInfoValue: e.target.value });
    this.props.disableContinueButton(false);
  }

  getFormData = () => {
    let reqParams = {};
    const employeeCardInfoObj = _.find(this.state.transferenceData.employeeCardInfo, { accountId: this.state.selectedRadioSavedCardsInfoValue });
    reqParams = {
      walletType: employeeCardInfoObj.accountName,
      walletOrEmployeeIdentifierId: employeeCardInfoObj.accountId,
      accountNumber: employeeCardInfoObj.accountNumber,
      walletOrEmployeeCardAmount: this.state.transferenceData.transferenceOptions.transferableAmount,
      walletUserName: employeeCardInfoObj.accountHolderName,
      totalAmount: this.state.transferenceData.transferenceOptions.transferableAmount,
      bonusAmount: this.state.transferenceData.transferenceOptions.bonusAmount,
      bonusPercentage: this.state.transferenceData.transferenceOptions.bonusPercentage,
    };
    return reqParams;
  }

  render() {
    const employeeCardInfo = {
      name: 'cardsInfo',
      options: [],
    };
    if (this.state.transferenceData && this.state.transferenceData.employeeCardInfo) {
      this.state.transferenceData.employeeCardInfo.map(card =>
        employeeCardInfo.options.push({
          id: 'radio_' + card.accountId,
          value: card.accountId,
          displayName: <span>{card.accountName} {card.accountHolderName}</span>,
          subDetailsHTML: <p>{card.accountNumber}</p>,
          selected: false,
        }),
      );
    }
    if (employeeCardInfo.options.length === 1 && this.state.selectedRadioSavedCardsInfoValue === null) {
      this.state.selectedRadioSavedCardsInfoValue = employeeCardInfo.options[0].value;
    }

    const paddingInputWAP = {
      padding: '8px 0 8px 5px',
    };

    const paddingInputWEB = {
      padding: '8px 0 8px 5px',
      marginLeft: '20px',
    };

    const iconStyle = {
      fontWeight: 700,
      paddingRight: '2%',
      marginTop: '-1%',
    };

    const textIconWAP = {
      color: '#333333',
      fontSize: '16px',
    };

    const amountIconWAP = {
      fontWeight: 700,
      color: '#333333',
      fontSize: '16px',
    };

    const tooltipWap = {
      width: '282px',
      left: '375%',
    };

    const displayFlexWeb = {
      display: 'flex',
      marginBottom: '0',
      alignItems: 'center',
    };

    return (
      <div>
        {channel === constChannels.WAP ? (
          <React.Fragment>
            <div className="test">
              <div className="row col-xs-12">
                {employeeCardInfo.options.length >= 1 ? (
                  <div>
                    {employeeCardInfo.options.map((option, index) => (
                      <div
                        className="row"
                        key={index}
                        style={{ paddingLeft: '9%' }}
                      >
                        <RadioButton
                          checked={
                            this.state.selectedRadioSavedCardsInfoValue ===
                            option.value
                          }
                          displayName={option.displayName}
                          id={option.id}
                          value={option.value}
                          name="savedCardInfo"
                          radioCssClass={'radio radioDF selectCard'}
                          onChangeFunction={this.handleRadioSelected}
                          style={{ color: '#333333' }}
                        />
                        <TextInput
                          className="inputMaterial"
                          style={paddingInputWAP}
                          labelClassName="placeHolderMaterial"
                          inputValue={option.subDetailsHTML.props.children.replaceAll(
                            'X',
                            '*',
                          )}
                          readOnly
                        />
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
              <div
                className="col-xs-12 inputsBlock display-block"
                style={{ padding: '0 10px' }}
              >
                <i
                  className="iClass icon-ayuda tooltip-container text-pink"
                  style={iconStyle}
                >
                  <span
                    className="tooltip-box tooltipBox344  tooltipIcon344"
                    style={tooltipWap}
                  >
                    Es el monto disponible y aprobado para cierre
                  </span>
                </i>
                <span style={textIconWAP}>Disponible para cierre</span>
                <p>
                  <span className="estimatedQuant" style={amountIconWAP}>
                    {commonUtil.getCurrency(
                      this.state.transferenceData.transferenceOptions
                        .transferableAmount,
                    )}
                  </span>
                </p>
                <div />

                <div>
                  {+this.state.transferenceData.transferenceOptions
                    .bonusAmount !== 0 ? (
                      <div>
                        <p
                          style={{
                            fontSize: '22px',
                            color: '#333333',
                            textAlign: 'center',
                          }}
                        >
                        +
                      </p>
                        <p>
                          <i
                            className="iClass icon-ayuda tooltip-container text-pink"
                            style={iconStyle}
                          >
                            <span
                              className="tooltip-box tooltipBox344  tooltipIcon344"
                              style={tooltipWap}
                            >
                              {
                              +this.state.transferenceData.transferenceOptions
                                .bonusPercentage
                            }
                            % {this.bonusToolTipMessage}
                            </span>
                          </i>
                          <span style={textIconWAP}>Bono total&nbsp;</span>
                        </p>
                        <p style={{ fontWeight: 700 }}>
                          <span
                            className="estimatedQuant"
                            style={{ fontWeight: 700, fontSize: '16px' }}
                          >
                            {commonUtil.getCurrency(
                            this.state.transferenceData.transferenceOptions
                              .bonusAmount,
                          )}
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: '22px',
                            color: '#333333',
                            textAlign: 'center',
                          }}
                        >
                        =
                      </p>
                        <p style={textIconWAP}>Total</p>
                        <p>
                          <span
                            className="estimatedQuant"
                            style={{ fontWeight: 700, fontSize: '16px' }}
                          >
                            {commonUtil.getCurrency(
                            +this.state.transferenceData.transferenceOptions
                              .transferableAmount +
                              +this.state.transferenceData.transferenceOptions
                                .bonusAmount,
                          )}
                          </span>
                        </p>
                      </div>
                  ) : null}
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="row" style={{ paddingLeft: '20px' }}>
            <div className="row">
              {employeeCardInfo.options.length >= 1 ? (
                <div className="col-xs-7">
                  <div>
                    {employeeCardInfo.options.map((option, index) => (
                      <div className="row" key={index}>
                        <div className="col-xs-7">
                          <RadioButton
                            checked={
                              this.state.selectedRadioSavedCardsInfoValue ===
                              option.value
                            }
                            displayName={option.displayName}
                            id={option.id}
                            value={option.value}
                            name="savedCardInfo"
                            radioCssClass={'radio selectCard'}
                            onChangeFunction={this.handleRadioSelected}
                            style={{ color: '#333333' }}
                          />
                          <TextInput
                            className="inputMaterial"
                            style={paddingInputWEB}
                            labelClassName="placeHolderMaterial"
                            inputValue={option.subDetailsHTML.props.children.replaceAll(
                              'X',
                              '*',
                            )}
                            readOnly
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>

            <div className="row" id="option1" style={displayFlexWeb}>
              <div className="col-md-3 col-sm-3">
                <i
                  className="iClass icon-ayuda tooltip-container text-pink"
                  style={iconStyle}
                >
                  <span className="tooltip-box tooltipBox344  tooltipIcon344">
                    Es el monto disponible y aprobado para cierre
                  </span>
                </i>
                <span style={{ fontSize: '14px', color: '#333333' }}>
                  Disponible para cierre&nbsp;
                </span>
                <div>
                  <strong className="quantity">
                    {commonUtil.getCurrency(
                      this.state.transferenceData.transferenceOptions
                        .transferableAmount,
                    )}
                  </strong>
                </div>
              </div>
              {+this.state.transferenceData.transferenceOptions.bonusAmount !==
              0 ? (
                <React.Fragment>
                  <div className="wrapOperator">
                    <div className="operator">+</div>
                  </div>
                  <div className="col-md-2 col-sm-2">
                    <i
                      className="iClass icon-ayuda tooltip-container text-pink"
                      style={iconStyle}
                    >
                      <span className="tooltip-box tooltipBox344  tooltipIcon344">
                        {
                          +this.state.transferenceData.transferenceOptions
                            .bonusPercentage
                        }
                        % {this.bonusToolTipMessage}
                      </span>
                    </i>
                    <span style={{ fontSize: '14px', color: '#333333' }}>
                      Bono total&nbsp;
                    </span>
                    <div>
                      <strong className="quantity">
                        {commonUtil.getCurrency(
                          this.state.transferenceData.transferenceOptions
                            .bonusAmount,
                        )}
                      </strong>
                    </div>
                  </div>
                  <div className="wrapOperator">
                    <div className="operator">=</div>
                  </div>
                  <div className="col-md-3 col-sm-3">
                    <span style={{ fontSize: '14px', color: '#333333' }}>
                      &nbsp;&nbsp;&nbsp;&nbsp;Total
                    </span>
                    <div>
                      <strong className="quantity">
                        {commonUtil.getCurrency(
                          +this.state.transferenceData.transferenceOptions
                            .transferableAmount +
                            +this.state.transferenceData.transferenceOptions
                              .bonusAmount,
                        )}
                      </strong>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
            </div>
            <br />
          </div>
        )}
      </div>
    );
  }

}
